<div class="edit-dialog-container">
  <div class="dialog-header">
    <p><strong>Edit Collection Name</strong></p>
    <button class="close-dialog" mat-icon-button (click)="dialogRef.close()"><mat-icon>close</mat-icon></button>
  </div>
  <div class="name-input-container">
    <p>{{ collection.name }}</p>
    <mat-icon>arrow_right</mat-icon>
    <mat-form-field appearance="outline" color="accent">
      <input
        (input)="updateCollectionName($event)"
        (keypress)="handleKeyDown($event)"
        type="text"
        placeholder="Enter new name"
        [value]="newCollectionName"
        matInput />
    </mat-form-field>
  </div>
  <div class="button-container">
    <button (click)="dialogRef.close(newCollectionName)" mat-flat-button color="primary">Save Changes</button>
    <button (click)="dialogRef.close()" mat-flat-button color="warn">Cancel</button>
  </div>
</div>
